import React, { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

type Props = {
    heading?: string;
    description?: string;
    className?: string;
};

/*
This is intended to be the main component at the top of a landing page. For the time being it just has a main heading and some extra text below it. 
In the future the same component could be used to have come kind of CTA (call-to-action) and background image etc.
*/

export const Hero: React.FC<PropsWithChildren<Props>> = props => {
    const { t } = useTranslation();
    return (
        <div className={`body-header ${props.className ?? ""}`}>
            {props.heading ? <h1>{t(props.heading)}</h1> : ""}
            {props.description ? <p>{t(props.description)}</p> : ""}
            {props.children}
        </div>
    );
};
